import { PermissionResource } from '@entities/client/permission';

import { requirePermission } from '../../../require-permission';

export const cardsLoader = requirePermission(PermissionResource.ClientCards);
